import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CardTypesEnum } from '@App/pages/pricing/pricing.service';
import { NgForOf } from '@angular/common';
import { RestApiService } from '@App/common/services';
import { NotificationService } from '@Shared/services';

@Component({
  selector: 'app-pricing-card-type-select',
  templateUrl: './pricing-card-type-select.component.html',
  styleUrls: ['./pricing-card-type-select.component.scss'],
  imports: [NgForOf],
  standalone: true
})
export class PricingCardTypeSelectComponent {
  @Input() businessId: string | number = '';
  @Output() cardTypeSelected = new EventEmitter<CardTypesEnum>();

  // Expose enum for template
  readonly CardTypesEnum = CardTypesEnum;

  // Card type options with descriptions
  readonly cardTypeOptions = [
    {
      tempType: 'employee',
      type: CardTypesEnum.Business,
      title: 'Business PitchCard',
      features: [
        'For EVERYONE in any type of business',
        'Emotionally connect with clients with your 59-second elevator pitch',
        'Make it easy for customers to refer you in just 5 seconds',
        'Great for business networking and introductions'
      ],
      image: 'assets/images/pricing-images/image-business.png',
      buttonText: 'Choose Business Card'
    },
    {
      tempType: 'resume',
      type: CardTypesEnum.Resume,
      title: 'Job Seeker PitchCard',
      features: [
        'For ANYONE seeking employment or internship opportunities',
        'Emotionally connect with potential employers with your elevator pitch',
        'Allows your friends, family, and network to easily introduce you to their contacts',
        'Great for networking and standing out from the crowd'
      ],
      image: 'assets/images/pricing-images/image-resume.png',
      buttonText: 'Choose Resume Card'
    }
  ];
  selectedType: string;
  @Output() paymentSuccess: EventEmitter<{
    id: string | number;
    businessType: string;
  }> = new EventEmitter();

  constructor(
    private restApiService: RestApiService,
    private notificationService: NotificationService
  ) {}

  selectCardType(cardType: string): void {
    this.selectedType = cardType;
    const businessId = this.businessId;
    this.restApiService
      .put(
        'select-pitchcard-type',
        `business/${businessId}/${cardType}/setup-type`
      )
      .subscribe({
        next: (response: boolean) => {
          if (response) {
            this.paymentSuccess.emit({
              id: this.businessId,
              businessType: this.selectedType
            });
          } else {
            this.notificationService.showNotification(
              'ERROR',
              'Failed to select card type. Please try again.'
            );
          }
        }
      });
  }
}
